<template>
  <div class="modal fade" id="addBehaviorTrackerModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">New Behavior Tracker</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6 v-if="errorMessage != ''" class="text-danger">
            {{ errorMessage }}
          </h6>
          <transition name="slide-fade" mode="out-in">
            <form
              v-if="!newScoreTemplate && page == 1"
              @submit.prevent="nextPage"
            >
              <div class="form-group">
                <label
                  ><strong>{{ Student.Name }}</strong></label
                >
              </div>
              <div class="form-group">
                <label for="name">Tracker Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Ex. John Term 1, Specials Tracker, etc."
                  v-model="newTrackerName"
                  required
                />
              </div>
              <div class="form-group">
                <label for="description">Tracker Description</label>
                <input
                  type="text"
                  class="form-control"
                  id="description"
                  placeholder="Tracker Description"
                  v-model="newTrackerDescription"
                />
              </div>
              <div class="form-group">
                <p class="mb-2">Tracker Settings</p>
                <div class="form-row mb-2">
                  <div
                    class="col-auto"
                    v-for="setting in selectedSettings"
                    :key="setting.Behavior_Setting_Id + 'selectedSetting'"
                  >
                    <p class="mb-0">-{{ setting.Title }}</p>
                  </div>
                </div>
                <button
                  class="btn btn-sm btn-primary"
                  type="button"
                  v-on:click="page = 3"
                >
                  Choose Settings
                </button>
              </div>
              <div v-if="ScoreTemplates != null" class="form-group">
                <label for="scoreTemplate">Tracker Form Template</label>
                <button
                  type="button"
                  class="btn btn-sm btn-link d-inline ml-2 pb-1"
                  v-on:click="newScoreTemplate = true"
                >
                  Create New Tracker Template
                </button>
                <select
                  id="scoreTemplate"
                  name="scoreTemplatePicker"
                  class="selectpicker d-block"
                  data-style="btn-outline-primary"
                  data-none-selected-text="Select Score Template"
                  data-actions-box="true"
                  data-selected-text-format="count"
                  v-model="selectedScoreTemplate"
                >
                  <option
                    v-for="template in ScoreTemplates.filter(
                      t => t.Score_Template_Type_Id == 2
                    )"
                    :key="template.Score_Template_Id"
                    v-bind:value="template"
                  >
                    {{ template.Title }}
                  </option>
                </select>
              </div>
              <div class="text-left ml-2" v-if="selectedScoreTemplate != null">
                <div
                  v-for="input in selectedScoreTemplate.Score_Template_Inputs.slice().sort(
                    $orderByOrder
                  )"
                  :key="input.Score_Template_Input_Id"
                >
                  <label class="mb-0"
                    >{{ input.Order }}) {{ input.Request }}</label
                  >
                  <label class="ml-2"
                    ><small
                      >({{ $getScoreTemplateInputSummary(input) }})</small
                    ></label
                  >
                </div>
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary">
                  Next
                </button>
              </div>
            </form>
            <form
              v-if="!newScoreTemplate && page == 2"
              @submit.prevent="createTracker"
            >
              <div class="form-group">
                <label
                  ><strong>Add Users to {{ newTrackerName }}</strong></label
                >
              </div>
              <div
                v-for="user in Users.slice().sort($orderByLastName)"
                :key="user.User_Id + 'assign'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="user.User_Id + 'assign'"
                  v-bind:value="user"
                  v-model="selectedUsers"
                />
                <label
                  class="form-check-label"
                  v-bind:for="user.User_Id + 'assign'"
                  >{{ user.First_Name }} {{ user.Last_Name }}</label
                >
              </div>
              <div class="row">
                <div class="col text-left">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="previousPage()"
                  >
                    Back
                  </button>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary">
                    Create Tracker
                  </button>
                </div>
              </div>
            </form>
            <form v-if="page == 3" key="settings">
              <div class="form-group">
                <label
                  ><strong>Settings for {{ newTrackerName }}</strong></label
                >
              </div>
              <div
                v-for="setting in BehaviorSettings.slice().sort($orderByTitle)"
                :key="setting.Behavior_Setting_Id + 'setting'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="setting.Behavior_Setting_Id + 'setting'"
                  v-bind:value="setting"
                  v-model="selectedSettings"
                />
                <label
                  class="form-check-label"
                  v-bind:for="setting.Behavior_Setting_Id + 'setting'"
                  >{{ setting.Title }}</label
                >
              </div>
              <form @submit.prevent="addSetting">
                <div class="form-group">
                  <label for="newSetting">New Setting</label>
                  <div class="form-row">
                    <div class="col">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Ex. P.E., Recess, Time with Jenny, etc."
                        v-model="newSetting"
                      />
                    </div>
                    <div class="col-auto">
                      <button class="btn btn-primary">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div class="text-right">
                <button
                  class="btn btn-primary"
                  type="button"
                  v-on:click="previousPage"
                >
                  Save Settings
                </button>
              </div>
            </form>
            <ScoreTemplateCreator
              v-if="newScoreTemplate"
              v-bind:Subject="{ Organization_Id: OrganizationId }"
              v-bind:ScoreTemplateType="2"
              v-bind:OrganizationId="OrganizationId"
              @cancel-creator="cancelTemplateCreator"
              @added-score-template="scoreTemplateAdded"
            />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ScoreTemplateCreator from "@/components/Score/ScoreTemplateCreator.vue";

export default {
  components: {
    ScoreTemplateCreator
  },
  props: {
    Student: Object,
    ScoreTemplates: Array,
    Users: Array,
    OrganizationId: Number,
    BehaviorSettings: Array
  },
  data() {
    return {
      newTrackerName: "",
      newTrackerDescription: "",
      newScoreTemplate: false,
      selectedScoreTemplate: null,
      selectedUsers: [],
      selectedSettings: [],
      page: 1,
      newSetting: "",
      errorMessage: ""
    };
  },
  watch: {
    Student: function() {
      this.clearFields();
    }
  },
  mounted() {
    var view = this;
    $("#addBehaviorTrackerModal").on("hidden.bs.modal", function() {
      if (view.editing) {
        view.$emit("edit-closed");
      }
    });
    $("#addBehaviorTrackerModal").on("shown.bs.modal", function() {
      $("#name").focus();
      var CONTROL_INTERVAL = setInterval(function() {
        if ($("#scoreTemplate").length > 0) {
          $(".selectpicker").selectpicker("refresh");
          clearInterval(CONTROL_INTERVAL);
        }
      }, 100);
    });
  },
  methods: {
    async createTracker() {
      $("#addBehaviorTrackerModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var behaviorTrackerToCreate = {
        Title: view.newTrackerName,
        Description: view.newTrackerDescription,
        Student_Id: view.Student.Student_Id,
        Score_Template: view.selectedScoreTemplate,
        Behavior_Tracker_Scores: [],
        Is_Archived: false
      };

      await view
        .$createBehaviorTracker(behaviorTrackerToCreate)
        .then(async newTracker => {
          await view
            .$createBehaviorTrackerSettings(
              newTracker.Behavior_Tracker_Id,
              view.selectedSettings.map(s => s.Behavior_Setting_Id)
            )
            .then(async () => {
              await view
                .$createBehaviorTrackerUsersAssignments(
                  newTracker.Behavior_Tracker_Id,
                  view.selectedUsers.map(u => u.User_Id)
                )
                .then(() => {
                  view.$store.commit("updateLoading", false);
                  newTracker.Settings = view.selectedSettings;
                  newTracker.Users = view.selectedUsers;
                  view.$emit("added-tracker", newTracker);
                  this.clearFields();
                });
            });
        })
        .catch(e => {
          console.log(e);
          $("#addBehaviorTrackerModal").modal("show");
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.newTrackerName = "";
      this.newTrackerDescription = "";
      this.newScoreTemplate = false;
      this.selectedScoreTemplate = null;
      this.page = 1;
      this.selectedUsers = [];
      this.selectedSettings = [];
    },
    scoreTemplateAdded(scoreTemplate) {
      this.ScoreTemplates.push(scoreTemplate);
      this.selectedScoreTemplate = scoreTemplate;
      this.updatePicker();
      this.newScoreTemplate = false;
    },
    nextPage() {
      switch (this.page) {
        case 1:
          if (this.selectedSettings.length == 0) {
            this.errorMessage =
              "Please select at least one setting for the behavior tracker.";
          } else if (this.selectedScoreTemplate == null) {
            this.errorMessage =
              "Please select a score template for the behavior tracker.";
          } else {
            this.errorMessage = "";
            this.page = 2;
          }
      }
    },
    previousPage() {
      this.errorMessage = "";
      switch (this.page) {
        case 2:
          this.page = 1;
          this.updatePicker();
          break;
        case 3:
          this.page = 1;
          this.updatePicker();
          break;
      }
    },
    updatePicker() {
      var CONTROL_INTERVAL = setInterval(function() {
        if ($("#scoreTemplate").length > 0) {
          $("#scoreTemplate").selectpicker("val", this.selectedScoreTemplate);
          $(".selectpicker").selectpicker("refresh");
          clearInterval(CONTROL_INTERVAL);
        }
      }, 100);
    },
    cancelTemplateCreator() {
      this.newScoreTemplate = false;
      this.updatePicker();
    },
    async addSetting() {
      if (this.newSetting != "") {
        this.errorMessage = "";
        await this.$createBehaviorSetting(
          this.newSetting,
          "",
          this.OrganizationId
        ).then(res => {
          this.BehaviorSettings.push(res);
          this.newSetting = "";
          this.selectedSettings.push(res);
        });
      } else {
        this.errorMessage =
          "You cannot add a blank setting. Please name the new setting and try again.";
      }
    }
  }
};
</script>
